import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import { useEffect } from "react";
import { useState } from "react";
export const SBDateRangePicker = ({ value, onChange, ...props }) => {
    const [dateValue, setDateValue] = useState(value);
    useEffect(() => {
        setDateValue(value);
    }, [value]);
    const handleOnChange = (e) => {
        if (e?.value) {
            setDateValue(e.value);
            if (onChange) {
                onChange(e);
            }
        }
    };
    return <>
        <DateRangePicker
            className="SbaDateRage"
            value={dateValue}
            startDateInputSettings={{ label: null }}
            endDateInputSettings={{ label: null }}
            onChange={handleOnChange}
            // show={true}
            popupSettings={{className:"dateRangeModal",show:true}}
            format={'MM/dd/yyyy'}
            {...props}
        />
    </>
}